import { ExerciseForm, Provider } from '@strength/domain';
import { RouterInput } from '../../../../../trpc';
import { v4 } from 'uuid';

export const createExerciseInput = (
  libraryExerciseId: string,
  exercise: ExerciseForm,
  teamId?: string,
): RouterInput['exerciseLibrary']['createExercise'] => {
  const {
    bodyParts,
    equipment,
    tags,
    defaultMetrics,
    integrationProviderProperties,
    trainingType,
    ...rest
  } = exercise;

  if (!trainingType) {
    // This should never happen
    throw new Error('Training type is required');
  }

  return {
    id: libraryExerciseId,
    ...rest,
    // Need to pass this up to create it, in case it is new
    trainingType,
    trainingTypeId: trainingType.id,
    exerciseBodyParts: bodyParts.map(({ id, name }, sortOrder) => ({
      id: v4(),
      bodyPart: { id, name },
      sortOrder,
    })),
    exerciseEquipment: equipment.map(({ id, name }, sortOrder) => ({
      id: v4(),
      equipmentItem: { id, name },
      sortOrder,
    })),
    exerciseTags: tags.map(({ id, name, type }, sortOrder) => ({
      id: v4(),
      tag: { id, name, type },
      sortOrder,
    })),
    defaultMetrics: defaultMetrics.map((metric, sortOrder) => ({
      id: v4(),
      metric,
      libraryExerciseId,
      sortOrder,
    })),
    integrationProperties: integrationProviderProperties.reduce(
      (acc, { provider, property, value }) => ({
        ...acc,
        [provider as Provider]: {
          ...acc[provider as Provider],
          [property]: value,
        },
      }),
      {} as Record<Provider, Record<string, string | number | boolean>>,
    ),
    teamId,
  };
};
